import Form from './Form'
import HasError from './components/HasError.vue'
import HasError4 from './components/HasError4.vue'
import AlertError from './components/Error.vue'
import AlertErrors from './components/Errors.vue'
import AlertSuccess from './components/Success.vue'

export {
  Form,
  HasError,
  HasError4,
  AlertError,
  AlertErrors,
  AlertSuccess,
  Form as default
}



// WEBPACK FOOTER //
// ./src/index.js